<edr-spinner class="button-spinner" *ngIf="isLoading" [color]="loadingSpinnerColor"></edr-spinner>
<ng-content *ngIf="!isLoading"></ng-content>
